import { isValidEmailAddress, isValidPassword } from '../functions';


$(document).ready(function() {

    var isLoadingRegister = false;
    $(document).on('click', '#register-btn', function() {

        if (isLoadingRegister) {
            console.log('is loading...');
            return false;
        }

        $('#register-form').find('.form-error-msg').html('');
        $('#register-form').find('.has-error').removeClass('has-error');

        var errorsFields = false;
        var errorsPassword = false;
        var errorsPasswordInvalid = false;
        var errorsEmailInvalid = false;
        var errorsAgree = false;
        var errorsTerms = false;

        if($('#reg_first_name').val() == '') {
            errorsFields = true;
            $('#reg_first_name').parent().addClass("has-error");
        }
        if($('#reg_last_name').val() == '') {
            errorsFields = true;
            $('#reg_last_name').parent().addClass("has-error");
        }
        if($('#reg_email').val() == '') {
            errorsFields = true;
            $('#reg_email').parent().addClass("has-error");
        } else if(!isValidEmailAddress($('#reg_email').val())) {
            errorsEmailInvalid = true;
            $('#reg_email').parent().addClass("has-error");
        }
        if($('#reg_phone').val() == '') {
            errorsFields = true;
            $('#reg_phone').parent().addClass("has-error");
        }
        if($('#reg_phone').val() == '') {
            errorsFields = true;
            $('#reg_phone').parent().addClass("has-error");
        }
        if($('#reg_password').val() == '') {
            errorsFields = true;
            $('#reg_password').parent().addClass("has-error");
        }
        if(!isValidPassword($('#reg_password').val())) {
            errorsPasswordInvalid = true;
            $('#reg_password').parent().addClass("has-error");
        }
        if ($('#reg_password').val() != $('#reg_password_confirmation').val()) {
            errorsPassword = true;
            $('#reg_password').parent().addClass("has-error");
            $('#reg_password_confirmation').parent().addClass("has-error");
        }
        if (!$('#reg_agree').is(':checked')) {
            errorsAgree = true;
            $('#reg_agree').parent().addClass("has-error");
            $('#reg_agree').focus();
        }
        if (!$('#reg_terms_and_conditions').is(':checked')) {
            errorsTerms = true;
            $('#reg_terms_and_conditions').parent().addClass("has-error");
            $('#reg_terms_and_conditions').focus();
        }

        if (errorsFields) {
            $('#register-form').find(".form-error-msg").html("נא למלא את כל השדות המסומנים").attr('role', 'alert');
            return false;
        } else if(errorsEmailInvalid) {
            $('#register-form').find(".form-error-msg").append("<div>נא למלא שדה אימייל תקין</div>").attr('role', 'alert');
            $('#reg_email').focus();
            return false;
        } else if (errorsPasswordInvalid) {
            $('#register-form').find(".form-error-msg").append("<div style='text-align:center;margin:7px 0;'>הסיסמא שהזנת שגויה. הסיסמא צריכה להכיל לפחות <b>6 תווים</b> ולכלול לפחות:<br>אות אחת באנגלית ולפחות ספרה אחת<br />לנוחיותך ניתן ללחוץ על סימן \"העין\" בשדה ולראות את שהוזן ולתקן.</div>").attr('role', 'alert');
            $('#reg_password').focus();
            $('#password-tooltip').attr('title','הסיסמא צריכה להכיל 6 תווים ולכלול לפחות:<br><b>אות אחת באנגלית ולפחות ספרה אחת</b><br>לנוחיותך ניתן ללחוץ על סימן "העין" בשדה ולראות את שהוזן.');
            $('#password-tooltip').tooltip();
            $('#password-tooltip').tooltip("show");
            return false;
        } else if (errorsPassword) {
            $('#register-form').find(".form-error-msg").append("<div>הסיסמאות צריכות להיות זהות</div>").attr('role', 'alert');
            $('#reg_password').focus();
            return false;
        }

        if (errorsAgree) {
            $('#register-form').find(".form-error-msg").append("<div>יש לאשר את תנאי ההרשמה המסומנים מעלה</div>").attr('role', 'alert');
            return false;
        }

        if (errorsTerms) {
            $('#register-form').find(".form-error-msg").append("<div>יש לאשר את תנאי ההרשמה המסומנים מעלה</div>").attr('role', 'alert');
            return false;
        }

        //Loading...
        isLoadingRegister = true;
        $('#register-btn').append('<i class="fa fa-spinner fa-spin" style="margin-right: 20px"></i>');

        var values = '_token=' + $('#_token_register').val();
		values += '&first_name=' + $('#reg_first_name').val();
		values += '&last_name=' + $('#reg_last_name').val();
		values += '&email=' + $('#reg_email').val();
		values += '&phone=' + $('#reg_phone').val();
		values += '&date_of_birth=' + $('input[name="date_of_birth_submit"]').val();
		values += '&password=' + $('#reg_password').val();
		values += '&password_confirmation=' + $('#reg_password_confirmation').val();
		values += '&agree=' + ($('#reg_agree').is(':checked')?1:'');
		values += '&terms_and_conditions=' + ($('#reg_terms_and_conditions').is(':checked')?1:'');
		$.ajax({
            type: "POST",
            url: baseURL + "/register",
            data: values,
            success: function(response) {
                isLoadingRegister = false;
                $('#register-btn').find('i').remove();

				if (response.status == 0) {
					var errorHtml = '';
					for(var errorKey in response.errors) {
						if(!response.errors.hasOwnProperty(errorKey)) continue;
						for(var error in response.errors[errorKey]) {
							$("#reg_"+errorKey).parent().addClass('has-error');
							errorHtml += response.errors[errorKey][error] + '<br>';
						}
					}

					$('#register-form').find(".form-error-msg").html('<div>'+errorHtml+'</div>').attr('role', 'alert');
					return false;
				}

				if (response.status == 1) {

                    $('#register-form').find('.form-control').val('');

                    $('#registerModal').modal('hide');
                    
                    $('#welcomeModal').modal('show');
                    $('#welcomeModal').find('.wecolme-name').html(response.data.name);
                    return false;
				}

                $('#register-form').find(".form-error-msg").html('<div>שגיאה: משהו השתבש, אנא צור קשר עם מנהל מערכת</div>').attr('role', 'alert');
            },
            error(error) {
                isLoadingRegister = false;
                $('#register-btn').find('i').remove();
                $('#register-form').find(".form-error-msg").html('<div>שגיאה: משהו השתבש, אנא צור קשר עם מנהל מערכת</div>').attr('role', 'alert');
            }
        });
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/register.js